import type * as React from 'react';

function SvgHamburgerMenu(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 16 16" width="1em" {...props}>
      <path
        d="M15.077 13.538a.924.924 0 010 1.847H.923a.923.923 0 010-1.847h14.154zm0-6.769a.923.923 0 010 1.846H.923a.923.923 0 110-1.846h14.154zm0-6.769a.923.923 0 110 1.846H.923A.923.923 0 11.923 0h14.154z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgHamburgerMenu;
